import { useTranslation } from "react-i18next"

import { SectionHeading } from "../components/SectionHeading"
import {
  BODY,
  CARD,
  CONTAINER,
  DASH_ITEM,
  DASH_LIST,
  H3,
  SECTION_SOFT,
} from "../components/styles"
import { ANCHORS } from "../site-config"

/** 业务模式：零售 / 代理团购两种购买方式 + 一次完整交易流程 */
export function ModelSection() {
  const { t } = useTranslation()

  return (
    <section id={ANCHORS.model} className={`${SECTION_SOFT} scroll-mt-[68px]`}>
      <div className={CONTAINER}>
        <SectionHeading
          eyebrow={t("official_model_eyebrow")}
          title={t("official_model_title")}
          lead={t("official_model_lead")}
        />

        <div className="grid gap-6 lg:grid-cols-2">
          <article className={CARD}>
            <span className="mb-2.5 inline-block rounded-full bg-primary-50 px-2.5 py-1 text-xs font-bold text-primary">
              {t("official_model_tag1")}
            </span>
            <h3 className={H3}>{t("official_model_c1_title")}</h3>
            <p className={BODY}>{t("official_model_c1_text")}</p>
            <ul className={`mt-3 ${DASH_LIST}`}>
              <li className={DASH_ITEM}>{t("official_model_c1_li1")}</li>
              <li className={DASH_ITEM}>{t("official_model_c1_li2")}</li>
              <li className={DASH_ITEM}>{t("official_model_c1_li3")}</li>
            </ul>
          </article>

          <article className={CARD}>
            <span className="mb-2.5 inline-block rounded-full bg-primary-50 px-2.5 py-1 text-xs font-bold text-primary">
              {t("official_model_tag2")}
            </span>
            <h3 className={H3}>{t("official_model_c2_title")}</h3>
            <p className={BODY}>{t("official_model_c2_text")}</p>
            <ul className={`mt-3 ${DASH_LIST}`}>
              <li className={DASH_ITEM}>{t("official_model_c2_li1")}</li>
              <li className={DASH_ITEM}>{t("official_model_c2_li2")}</li>
              <li className={DASH_ITEM}>{t("official_model_c2_li3")}</li>
            </ul>
          </article>
        </div>

        <div className={`mt-8 ${CARD}`}>
          <h3 className={H3}>{t("official_model_steps_title")}</h3>
          <ol className="mt-4 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            <li className="flex gap-3">
              <span className="grid h-[30px] w-[30px] shrink-0 place-items-center rounded-full bg-primary text-sm font-bold text-white">
                1
              </span>
              <div>
                <b className="mb-0.5 block text-[15px] text-ink">
                  {t("official_model_step1_title")}
                </b>
                <p className="m-0 text-sm leading-[1.6] text-ink-tertiary">
                  {t("official_model_step1_desc")}
                </p>
              </div>
            </li>
            <li className="flex gap-3">
              <span className="grid h-[30px] w-[30px] shrink-0 place-items-center rounded-full bg-primary text-sm font-bold text-white">
                2
              </span>
              <div>
                <b className="mb-0.5 block text-[15px] text-ink">
                  {t("official_model_step2_title")}
                </b>
                <p className="m-0 text-sm leading-[1.6] text-ink-tertiary">
                  {t("official_model_step2_desc")}
                </p>
              </div>
            </li>
            <li className="flex gap-3">
              <span className="grid h-[30px] w-[30px] shrink-0 place-items-center rounded-full bg-primary text-sm font-bold text-white">
                3
              </span>
              <div>
                <b className="mb-0.5 block text-[15px] text-ink">
                  {t("official_model_step3_title")}
                </b>
                <p className="m-0 text-sm leading-[1.6] text-ink-tertiary">
                  {t("official_model_step3_desc")}
                </p>
              </div>
            </li>
            <li className="flex gap-3">
              <span className="grid h-[30px] w-[30px] shrink-0 place-items-center rounded-full bg-primary text-sm font-bold text-white">
                4
              </span>
              <div>
                <b className="mb-0.5 block text-[15px] text-ink">
                  {t("official_model_step4_title")}
                </b>
                <p className="m-0 text-sm leading-[1.6] text-ink-tertiary">
                  {t("official_model_step4_desc")}
                </p>
              </div>
            </li>
          </ol>
        </div>
      </div>
    </section>
  )
}
